<template>
  <div class="info-card uni-search">
    <div class="info-card__top">
      <img v-if="logo" :src="logo" class="info-card__logo">
    </div>
    <div class="info-card__bottom" v-if="website && website !== 'null'">
      <div class="info-card__title">WEB SİTESİ</div>
      <div class="info-card__count">
        <a :href="getUrl" target="_blank" style="color:inherit"> {{ website }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UniInfoCard',
  props: {
    logo: String,
    website: String
  },
  computed: {
    getUrl () {
      return 'http://' + this.website
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/info-card";
  .info-card {
    opacity: 1;
    background: #fff;
    display: block;
    height: auto;
    max-width: 300px;
  }
  .info-card__logo {
    margin-bottom: 0;
  }
  .info-card__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .info-card__count {
    font-size: 18px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .info-card__top {
    padding: 21px 10px;
    border-bottom: 0;
  }
  .info-card__bottom {
    padding: 21px 15px;
    border-top: 1px solid #e7eaf1;
  }

  .info-card:hover {
    .info-card__title {
      color: #939bb3;
    }

    .info-card__count {
      color: #535b78;
    }
  }

</style>
